//import packages from node modules
import React, {useCallback, useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import renderHTML from 'react-render-html'
import {change} from 'redux-form'

//main component
const BoxField = (props) => {
    const {item,meta,input} = props
    const initFlag = useRef(null)
    const buttonRef = useRef(null)
    const [buttonHover,setButtonHover] = useState(false)
    const initCallback = useCallback(()=>{
        if(!initFlag.current && meta && item && input){
            const {initialValue} = item
            const {dispatch,form} = meta
            const {name} = input
            dispatch(change(form,name,!!initialValue))
            initFlag.current = true
        }
    },[initFlag,item,meta,input])

    useEffect(()=>{
        initCallback()
    },[initCallback])

    if(meta && item && input){
        const renderSymbol = () => {

            if(value){
                return (
                    <div className={'of-checkbox-box-field-symbol__tick icon-of-tick-solid icon'} />
                )
            }
            return (
                <div className={`of-checkbox-box-field-symbol of-checkbox-box-field-symbol--empty`}>
                    <div className={`of-checkbox-box-field-symbol__block text-background-1-100`} />
                    <div className={`of-checkbox-box-field-symbol__block text-background-1-100 of-checkbox-box-field-symbol__block--last`} />
                </div>
            )
        }
        const {description,label,price,cycle,discount} = item
        const {form,dispatch} =  meta
        const {value,name} = input
        const buttonOnClick = (e) => {
            e.preventDefault()
            dispatch(change(form,name,!value))
        }


        const renderPrice = (alignright) => {
            const renderTerms = () => {
                if(discount && price){
                    return (<div className={`text-font-4-100 of-checkbox-box-field-price__wrapper${alignright?' of-checkbox-box-field-price__wrapper--right':''}`}>
                        <div className={`of-checkbox-box-field-price__terms`}>(${`${price}${cycle} after the first invoice`})</div>
                    </div>)
                }
                return(<></>)
            }
            if(price && cycle){
                return (<div className={`of-checkbox-box-field-price--top of-checkbox-box-field-price${discount?' of-checkbox-box-field-price--sale':''}`}>
                    <div className={`of-checkbox-box-field-price__wrapper${discount?' status-font-3-100':' text-font-1-100'}${alignright?' of-checkbox-box-field-price__wrapper--right':''}`}>
                        <span className={`of-checkbox-box-field-price__value`}>${discount?discount.price:price}</span>
                        <span className={`of-checkbox-box-field-price__cycle`}>{cycle}</span>
                    </div>
                    {renderTerms()}
                </div>)
            }
            return (<></>)
        }
        const renderBottomPrice = () => {
            if(price && cycle){
                const renderSave = () => {
                    if(discount && discount.price){
                        const save = (parseFloat(discount.price)/parseFloat(price)) * 100
                        if(save){
                            return (<div className={'of-checkbox-box-field-price__save status-background-3-100'}>Save {Math.round(save)}%</div>)
                        }
                    }
                    return <></>
                }
                const renderPrice = (value,cyclename,strike=false,onSale=false) => {
                    return (
                        <div className={`of-checkbox-box-field-price__wrapper${strike?' of-checkbox-box-field-price__wrapper--strike text-font-4-100':` ${onSale?' status-font-3-100':' text-font-1-100'}`}`}>
                            <span className={`of-checkbox-box-field-price__value`}>${value}</span>
                            <span className={`of-checkbox-box-field-price__cycle`}>{cyclename}</span>
                        </div>
                    )
                }
                if(discount && discount.price){
                    return (<div className={`of-checkbox-box-field-price of-checkbox-box-field-price--on-sale`}>
                        <div className={`of-checkbox-box-field-price__sale-price`}>
                            {renderPrice(discount.price,cycle,false,true)}
                            {renderSave()}
                        </div>
                        <div className={`of-checkbox-box-field-price__normal-price`}>
                            {renderPrice(price,cycle,true)}
                        </div>
                    </div>)
                }
                return (<div className={`of-checkbox-box-field-price`}>
                    {renderPrice(discount?discount.price:price,cycle)}
                </div>)
            }
            return (<></>)
        }

        const onMouseEnter = () => {
            setButtonHover(true)
        }
        const onMouseLeave = () => {
            setButtonHover(false)
        }

        const getBackgroundClassName = () =>{
            if(value){
                if(buttonHover){
                    return 'status-background-1-30'
                }
                return 'status-background-1-20'
            }
            if(buttonHover){
                return 'primary-background-2-80'
            }
            return 'primary-background-2-100'
        }

        return (<div className={`of-checkbox-box-field lines-border-1-100`}>
            <div className={`of-checkbox-box-field__top lines-border-1-100`}>
                <div className={'of-checkbox-box-field__details'}>
                    <div className={'of-checkbox-box-field__recommend primary-background-1-100'}>
                        Recommended
                    </div>
                    <div className={`clear`}/>
                    <div className={'of-checkbox-box-field__name text-font-1-100'}>
                        {label}
                    </div>
                </div>
                <div className={`of-checkbox-box-field__action`}>
                    {renderPrice(true)}
                    <button ref={buttonRef} onClick={buttonOnClick}
                            onMouseEnter={onMouseEnter}
                            onMouseLeave={onMouseLeave}
                            className={`${value?'of-checkbox-box-field__button--added  status-font-1-100 ':' text-font-1-100 '}${getBackgroundClassName()} of-checkbox-box-field__button of-checkbox-box-field__button`}>
                        {renderSymbol()}
                        <span className={"text"}>{value?"Added":"Add"}</span>
                    </button>
                </div>
            </div>
            <div className={`of-checkbox-box-field__bottom`}>
                <div className={`of-checkbox-box-field__content clearfix text-font-3-100`}>
                    {renderHTML(description)}
                    {renderBottomPrice()}
                </div>
            </div>
        </div>)
    }
    return (<></>)

}

BoxField.propTypes = {
    item: PropTypes.object,
    input: PropTypes.object,
    meta: PropTypes.object
}


export default BoxField